module.exports = __webpack_public_path__ + "static/media/spicy-mama-hero-mobile-ont-man.9b0aa0c0.jpg";